import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';

import type { PrefetchedUserDataProps } from 'src/shared/prefetch';
import { withPrefetchedData } from 'src/shared/prefetch';

import type { UserInfo } from 'src/app/pages/petitionGamma/shared/types';
import { prefetchUserDataUserInfo, useUserInfo } from 'src/app/pages/petitionGamma/shared/userInfo';

import { CommonPetitionDetails } from './CommonPetitionDetails';

/**
 * This is the entrypoint rendered by the staff-only `/pgamma/:slug` route. It bypasses the old/new rollout checkout. It
 * isn't rendered by the `PetitionDetailsSubRouteRenderer`, so it has to fetch the `UserInfo` data that the
 * CommonPetitionDetails expects. Once the old page is removed, this can be replaced with a regular rendering of
 * `PetitionGammaDetails`. We'll also want to remove old-style UserInfo fetching, as noted in the
 * `PetitionHeaderContainer`.
 */
export const PetitionGammaStaffRoute = withPrefetchedData(
	({ prefetchedUserData }: PrefetchedUserDataProps<UserInfo>): JSX.Element | null => {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		const userInfoState = useUserInfo(slug, prefetchedUserData);

		return <CommonPetitionDetails userInfoState={userInfoState} />;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchUserData: async (context) => prefetchUserDataUserInfo(context),
		prefetchDependencies: [CommonPetitionDetails],
	},
);
